import { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { FaUser, FaPhone, FaCommentDots, FaMobileAlt } from "react-icons/fa";
import { getWhatsAppWebChannelDeviceInfo } from "../../../../services/api";

/**
 * Modal "Informações do Canal" — replica visual do OrbitSender:
 * foto + nome + telefone + sobre + dispositivo.
 */
export default function InfoModal({ show, channel, onClose }) {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !channel?.id) return;
    setLoading(true);
    setInfo(null);
    getWhatsAppWebChannelDeviceInfo(channel.id)
      .then((res) => setInfo(res?.data || null))
      .catch(() => setInfo(null))
      .finally(() => setLoading(false));
  }, [show, channel]);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>ℹ️ Informações do Canal</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {loading ? (
          <Spinner animation="border" />
        ) : !info ? (
          <p className="text-muted">
            Não foi possível carregar. O canal precisa estar ativo.
          </p>
        ) : (
          <>
            {info.imgUrl && (
              <img
                src={info.imgUrl}
                alt="Foto do canal"
                style={{
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  border: "3px solid #25D366",
                }}
              />
            )}
            <div className="mt-3 text-left">
              <InfoRow icon={<FaUser />} label="Nome" value={info.name || "—"} />
              <InfoRow
                icon={<FaPhone />}
                label="Telefone"
                value={
                  info.phone
                    ? formatPhone(info.phone)
                    : "—"
                }
              />
              <InfoRow
                icon={<FaCommentDots />}
                label="Sobre"
                value={info.about || "—"}
              />
              <InfoRow
                icon={<FaMobileAlt />}
                label="Dispositivo"
                value={info.originalDevice || "—"}
              />
              {info.isBusiness && (
                <span className="badge badge-success">Conta Business</span>
              )}
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

function InfoRow({ icon, label, value }) {
  return (
    <div
      className="d-flex align-items-center mb-2 p-2"
      style={{ background: "rgba(255,255,255,0.05)", borderRadius: 6 }}
    >
      <span className="text-muted mr-2">{icon}</span>
      <div className="ml-2">
        <small className="text-muted">{label}</small>
        <div>
          <strong>{value}</strong>
        </div>
      </div>
    </div>
  );
}

function formatPhone(p) {
  // 558894255312 → +55 (88) 9425-5312
  const s = String(p).replace(/\D/g, "");
  if (s.length < 10) return p;
  const ddi = s.slice(0, 2);
  const ddd = s.slice(2, 4);
  const rest = s.slice(4);
  if (rest.length === 9) {
    return `+${ddi} (${ddd}) ${rest.slice(0, 5)}-${rest.slice(5)}`;
  }
  return `+${ddi} (${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}`;
}
